var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C9.63185 22 7.66847 20.267 7.30888 18H6.70284C4.4233 18 2.67101 15.983 2.98965 13.7259L3.61689 9.28249C4.20653 5.10553 7.78125 2 11.9997 2C16.218 2 19.7927 5.10555 20.3823 9.28249L21.0096 13.7259C21.3282 15.983 19.576 18 17.2964 18H16.6911C16.3315 20.267 14.3681 22 12 22ZM5.10217 9.49215C5.58733 6.05529 8.52867 3.5 11.9997 3.5C15.4705 3.5 18.4118 6.05529 18.897 9.49215L19.5243 13.9355C19.7155 15.2898 18.6642 16.5 17.2964 16.5H6.70284C5.3351 16.5 4.28375 15.2898 4.47493 13.9355L5.10217 9.49215ZM15.163 18C14.8244 19.4333 13.5368 20.5 12 20.5C10.4632 20.5 9.17555 19.4333 8.83697 18H15.163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.027e30034f71152738306516ef5c16c9.svg";
export { ForwardRef as ReactComponent };